<template>
  <div>
    <md-card>
      <!-- 卡片-主体 -->
      <md-card-content>
        <!-- 卡片-主体-表单-表格数据筛选 -->
        <div class="md-layout card-form" style="max-width: 800px;">
          <!-- 表单-选择框-公司 -->
          <div class="md-layout-item md-size-30 left-layout-item md-xsmall-size-40">
            <md-field>
              <label>{{$I18n("state")}}</label>
              <md-select v-model="formData.state">
                <md-option value="0">{{$I18n("all")}}</md-option>
                <md-option value="1">{{$I18n("open")}}</md-option>
                <md-option value="2">{{$I18n("closed")}}</md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item md-size-30 left-layout-item md-xsmall-size-40">
            <md-field>
              <label>{{$I18n("type")}}</label>
              <md-select v-model="formData.type">
                <md-option value="0">{{$I18n("all")}}</md-option>
                <md-option value="1">{{$I18n("timed_event")}}</md-option>
                <md-option value="2">{{$I18n("dev_eve_sta")}}</md-option>
                <md-option value="3">{{$I18n("dev_eve_push")}}</md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item md-size-20">
            <md-button class= "left-icon md-info" @click="form_search">
              <md-icon>search</md-icon>
              {{$I18n("search")}}
            </md-button>
          </div>
        </div>
      </md-card-content>
    </md-card>
    <md-card>
      <!-- 卡片-主体 -->
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item">
            <add-button @click="() => table_addItem()">{{$I18n("add")}}</add-button>
          </div>
        </div>
        <!-- 
          ID 
          类型
          名称
          状态
          表达式
          更新时间
          创建时间
         -->
        <md-table v-model="tableData">
          <md-table-row slot="md-table-row" slot-scope="{ item }" >
            <md-table-cell :md-label="$I18n('id')">{{ item.id }}</md-table-cell>
            <md-table-cell :md-label="$I18n('type')">{{ item.type_name }}</md-table-cell>
            <md-table-cell :md-label="$I18n('name')">{{ item.name }}</md-table-cell>
            <md-table-cell :md-label="$I18n('state')">{{ item.state_name }}</md-table-cell>
            <md-table-cell :md-label="$I18n('spec')">{{ item.spec }}</md-table-cell>
            <md-table-cell :md-label="$I18n('update_date')">{{ item.update_date }}</md-table-cell>
            <md-table-cell :md-label="$I18n('created_thing_time')">{{ item.create_date }}</md-table-cell>
            <md-table-cell :md-label="$I18n('operate')"  class="button-box">
              <md-button @click="table_editItem(item)" class="md-just-icon md-round md-info left-icon">
                <md-icon>edit</md-icon>
              </md-button >
              <md-button @click="table_deleteItem(item)" class="md-just-icon md-round md-danger md-info" >
                <md-icon>close</md-icon>
              </md-button>
            </md-table-cell>
          </md-table-row>
          <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
        </md-table>
        <!-- 翻页 -->
        <table-page :total="total" :pageSize="pageSize" v-model="pageNo"/>
      </md-card-content>
    </md-card>
    <!-- 弹窗 -->
    <simple-modal 
      ref     = "modal"
      :title  = "modalTitle"
      :right  = "openModalType!=='delete'"
      @submit = "modal_submit"
    >
      <template slot="body">
        <!-- 删除弹窗 -->
        <div v-if="openModalType==='delete'">{{$I18n("check_delete", modalData.Form.name)}}</div>
        <!-- 修改/添加弹窗 -->
        <div class="md-layout" v-else>
          <template v-for="item in form_modalData">
            <common-form-item 
              :key="item.keys"
              v-if="!item.dataType"
              v-model="modalData.Form[item.keys]" 
              :error="modalData.Error[item.keys]" 
              v-bind="item"
            />

            <common-form-item 
              :key="item.keys"
              v-if="item.dataType ==='1' && modalData.Form.type === 1"
              v-model="modalData_1.Form[item.keys]" 
              :error="modalData_1.Error[item.keys]" 
              v-bind="item"
            />
            <common-form-item 
              :key="item.keys"
              v-if="item.dataType ==='2' && modalData.Form.type === 2"
              v-model="modalData_2.Form[item.keys]" 
              :error="modalData_2.Error[item.keys]" 
              v-bind="item"
            />
            <common-form-item 
              :key="item.keys"
              v-if="item.dataType ==='3' && modalData.Form.type === 3"
              v-model="modalData_3.Form[item.keys]" 
              :error="modalData_3.Error[item.keys]" 
              v-bind="item"
            />
          </template>
        </div>
      </template>
      <template v-if="openModalType!=='delete'" slot="footer-btn">
        <md-button class= "left-icon md-info" @click="api_post_now">
          {{$I18n("exe_imm")}}
        </md-button>
      </template>
    </simple-modal>
  </div>
</template>
<script>
import { FormClass, timestampToString1000 } from "@/common/tools.js";
export default {
  props: ["userinfo_sys"],
  data() {
    return {
      formData  : {
        type : "0",
        state: "0",
      },
      searchData: {
        type : "0",
        state: "0",
      },

      // Table 原始数据 (翻页)
      tableInitData: [],
      pageNo   : 1,
      total    : 0,
      // 每页的数量(统一)
      pageSize: 10,

      // 弹窗相关
      openModalType : "", // 弹窗类型
      modalTitle    : "", // 弹窗标题
      // 弹窗表单相关
      modalData : new FormClass({
        "name":"",
        "spec":"",
        "state":1,
        "type":1,
        "id"  :0,
      },{
        "name":"required",
        "spec":"required",
      }),
      modalData_1 : new FormClass({
        "uid":"",
        "alarm_type":1,
        "ch_no"     :1,
      },{
        "uid":"required",
        // 1~128
        "ch_no" : val => {
          if(isNaN(val)){
            return true
          }
          if(val < 1 || val > 128){
            return true
          }
        },
      }),
      modalData_2 : new FormClass({
        "push_type":0,
      }),
      modalData_3 : new FormClass({
        "push_type":0,
        "delay":0,
      },{
        "delay": val => {
          if(isNaN(val) || val <= 0){
            return true
          }
        },
      }),
    };
  },
  watch: {
    pageNo(){
      this.api_getPageData();
    },
  },
  computed:{
    // 表格数据处理
    tableData(){
      return [...this.tableInitData]
        .map(item => {
          let type_name = "";
          switch(item.type){
            case 1:
              type_name = this.$I18n("timed_event");
              break
            case 2:
              type_name = this.$I18n("dev_eve_sta");
              break
            case 3:
              type_name = this.$I18n("dev_eve_push");
              break
          }

          let state_name = "";
          switch(item.state){
            case 1:
              state_name = this.$I18n("open");
              break
            case 2:
              state_name = this.$I18n("closed");
              break
          }
          return {
            ...item,
            type_name,
            state_name,
            update_date: timestampToString1000(item.gmt_update),
            create_date: timestampToString1000(item.gmt_create),
          }
        })
    },
    form_modalData(){
      return [
        {
          label   : this.$I18n("type"),
          keys    : "type",
          type    : "select",
          required: true,
          options : [
            {id: 1,name: this.$I18n("timed_event"),},
            {id: 2,name: this.$I18n("dev_eve_sta"),},
            {id: 3,name: this.$I18n("dev_eve_push"),},
          ],
          disabled: this.openModalType !== "add",
          class   : "md-layout-item md-size-100",
        },{
          label   : this.$I18n("name"),
          keys    : "name",
          type    : "input",
          required: true,
          check   : true,
          class   : "md-layout-item md-size-100",
        },{
          label   : "UID",
          keys    : "uid",
          type    : "input",
          required: true,
          check   : true,
          dataType: "1",
          class   : "md-layout-item md-size-100",
        },{
          label   : this.$I18n("alarm_event"),
          keys    : "alarm_type",
          type    : "select",
          required: true,
          dataType: "1",
          options : this.$Param.alarmType.build().map(i => {
            return {
              id  : i.id,
              name: this.$I18n(i.name),
            }
          }),
          class   : "md-layout-item md-size-100",
        },{
          label   : this.$I18n("channel_num"),
          keys    : "ch_no",
          type    : "input",
          required: true,
          check   : true,
          dataType: "1",
          class   : "md-layout-item md-size-100",
        },{
          label   : this.$I18n("push_type"),
          keys    : "push_type",
          type    : "select",
          required: true,
          dataType: "2",
          options : [
            {id:0, name: this.$I18n("all"),},
            {id:1, name: this.$I18n("msg"),},
            {id:2, name: this.$I18n("email"),},
            {id:3, name: this.$I18n("sms"),},
            {id:4, name: this.$I18n("simple_phone"),},
          ],
          class   : "md-layout-item md-size-100",
        },{
          label   : this.$I18n("push_type"),
          keys    : "push_type",
          type    : "select",
          required: true,
          dataType: "3",
          options : [
            {id:0, name: this.$I18n("all"),},
            {id:1, name: this.$I18n("msg"),},
            {id:2, name: this.$I18n("email"),},
            {id:3, name: this.$I18n("sms"),},
            {id:4, name: this.$I18n("simple_phone"),},
          ],
          class   : "md-layout-item md-size-100",
        },{
          label   : this.$I18n("delay"),
          keys    : "delay",
          type    : "input",
          required: true,
          dataType: "3",
          check   : true,
          class   : "md-layout-item md-size-100",
        },{
          label   : this.$I18n("state"),
          keys    : "state",
          type    : "select",
          required: true,
          options : [
            {id:1, name: this.$I18n("open"),},
            {id:2, name: this.$I18n("closed"),},
          ],
          class   : "md-layout-item md-size-100",
        },{
          label   : this.$I18n("spec"),
          keys    : "spec",
          type    : "input",
          required: true,
          check   : true,
          class   : "md-layout-item md-size-100",
        }
      ]
    },
  },
  mounted(){
    this.api_getPageData();
  },
  methods: {
    // 查询
    form_search() {
      this.searchData = {...this.formData};
      this.pageNo = 1;
      this.api_getPageData();
    },
    api_getPageData() {
      this.$api.getCronList({
        ...this.searchData,
        page_no  : this.pageNo,
        page_size: this.pageSize,
      })
        .then(this.$Then(res => {
          this.tableInitData = res.data;
          this.total = res.count;
        }))

        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.tableInitData = [];
          this.total = 0;
        }))
    },
    // 添加
    table_addItem(){
      this.openModalType = "add";
      this.modalData.Reset();
      this.modalData_1.Reset();
      this.modalData_2.Reset();
      this.modalData_3.Reset();
      this.modalTitle = this.$I18n("add");
      this.$refs.modal.open();
    },
    // 修改
    table_editItem(item){
      try{
        var params = JSON.parse(item.param);
        this[`modalData_${item.type}`].Update(params)
      }catch(e){
        console.error(e);
        this.modalData_1.Reset();
        this.modalData_2.Reset();
        this.modalData_3.Reset();
      }
      this.openModalType = "edit";
      this.modalData.Update(item);
      this.modalTitle = this.$I18n("edit");
      this.$refs.modal.open();
    },
    // 删除
    table_deleteItem(item){
      this.modalData.Update(item);
      this.openModalType = "delete";
      this.modalTitle = this.$I18n("delete");
      this.$refs.modal.open();
    },
    api_post_now(){
      if(this.modalData.Check()){
        this.$errorMsg(this.$I18n("pls_check_verify"))
        return
      }
      var key = `modalData_${this.modalData.Form.type}`;
      if(this[key].Check()){
        this.$errorMsg(this.$I18n("pls_check_verify"))
        return
      }
      if(this.modalData.Form.type === 3){
        this[key].Form.delay = parseInt(this[key].Form.delay);
      }
      this.$api.notiPostNow({
        ...this.modalData.Form,
        param: JSON.stringify(this[key].Form),
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("succ_num"))
        }))
        .catch(this.$Catch(this.$I18n("fail_num")))
    },
    modal_submit(){
      if(this.openModalType === "delete"){ // 删除
        return this.$api.delCronList({...this.modalData.Form})
          .then(this.$Then(() => {
            this.$refs.modal.close();
            this.api_getPageData();
            this.$successMsg(this.$I18n("delete_success"))
          }))
          .catch(this.$Catch(this.$I18n("delete_fail")))
      }
      if(this.modalData.Check()){
        this.$errorMsg(this.$I18n("pls_check_verify"))
        return
      }
      var key = `modalData_${this.modalData.Form.type}`;
      if(this[key].Check()){
        this.$errorMsg(this.$I18n("pls_check_verify"))
        return
      }
      if(this.modalData.Form.type === 3){
        this[key].Form.delay = parseInt(this[key].Form.delay);
      }
      if(this.openModalType === "add"){
        this.$api.addCronList({
          ...this.modalData.Form,
          param: JSON.stringify(this[key].Form),
        })
          .then(this.$Then(() => {
            this.$refs.modal.close();
            this.api_getPageData();
            this.$successMsg(this.$I18n("add_success"))
          }))
          .catch(this.$Catch(this.$I18n("add_fail")))
      } else if (this.openModalType === "edit"){
        this.$api.setCronList({
          ...this.modalData.Form,
          param: JSON.stringify(this[key].Form),
        })
          .then(this.$Then(() => {
            this.$refs.modal.close();
            this.api_getPageData();
            this.$successMsg(this.$I18n("edit_success"))
          }))
          .catch(this.$Catch(this.$I18n("edit_fail")))
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  .left-layout{
    padding-left: 0;
  }
  .right-layout{
    padding-right: 0;
  }
  .md-card-only-title{
    margin: 0;
    box-shadow: none;
    text-align: left;
    position: relative;
    top: -12px;
    left: -20px;
  }
  .md-card-only-title .title{
    text-align:left !important;
  }
  .total-page{
    width: 30%;
    display: inline-block;
  }
  .left-btn {
    text-align:left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 表单里的单选框
  .radio-layout{
    margin-top: 6px;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  //左侧iocn
  .left-icon{
    margin-right: 16px;
  }
  // flaot 右的按钮
  .right-button {
    float:right;
  }

  .text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

  .table-stats {
    display: flex;
    align-items: center;
    text-align: right;
    flex-flow: row wrap;

    .td-price .td-total {
      display: inline-flex;
      font-weight: 500;
      font-size: 1.0625rem;
      margin-right: 50px;
    }

    &.table-striped .td-price {
      border-bottom: 0;
    }

    .td-price {
      font-size: 26px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }

    .td-price,
    > div {
      flex: 0 0 100%;
      padding: 12px 8px;
    }
  }
</style>